import { useMutation, useQueryClient } from '@tanstack/react-query';

import { API } from '@/shared/api';
import { CONFLICT_STATUS_CODE } from '@/shared/api/errors';
import { logout } from '@/shared/lib/logout';
import { isErrorGuard } from '@/shared/lib/types';
import { GTMEvents, MixpanelEvents, setMixpanelUser } from '@/shared/thirdParty';

import { LS_IS_JUST_SIGNED_IN_NAME, LS_NEW_USER_SHOW_UPLOAD_NAME, LS_NEW_USER_SHOW_UPLOAD_VALUE } from '../lib/constants';
import { USER_QUERY_KEYS } from '../lib/userQueryKeys';

type CreateUserParams = {
  isSocial?: boolean;
  onError?: () => void;
};

export const useCreateUser = ({ isSocial = false }: CreateUserParams) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: API.createUser,
    onError: (error) => {
      if (isErrorGuard(error, CONFLICT_STATUS_CODE)) {
        void logout();
        localStorage.clear();
        window.location.reload();
      }
    },
    onSuccess: async (newUser) => {
      await queryClient.setQueryData(USER_QUERY_KEYS.userData, newUser);

      setMixpanelUser(newUser.id, newUser.email, newUser.email_type);
      MixpanelEvents.signUp({ isSocial });
      GTMEvents.setUserId(newUser.id);
      GTMEvents.registration();
      // remove this LS item to prevent sending 'login' event after 'registration'
      localStorage.removeItem(LS_IS_JUST_SIGNED_IN_NAME);
      // set flag for new users to show upload modal
      localStorage.setItem(LS_NEW_USER_SHOW_UPLOAD_NAME, LS_NEW_USER_SHOW_UPLOAD_VALUE);
    },
  });
};
